import couplings from "@/store/modules/hose/couplings";
import hoses from "@/store/modules/hose/hoses";
import axios from "axios";
import hoseItems from "@/store/modules/hose/hoseItems";
import press from "@/store/modules/hose/press";
import cart from "@/store/modules/cart";

export default {
    namespaced: true,
    modules: {
        hoses,
        couplings,
        hoseItems,
        press,
        cart,
    },

    state: {
        preferences: {
            unit: 'bar',
            application: 'hydraulic',
            pressure: 0,
            lpm: 0,
            length: 1000,
            popupType: null,
            materialA: 'steel',
            materialB: 'steel',
        },
        build: {
            type: 1,
            couplingA: null,
            selectedCategoryA: null,
            couplingB: null,
            selectedCategoryB: null,
            rotation: null,
            selectedHose: null,
        },
        extras: {
            addTestCertificate: false,
            testCertificateBarAmount: null,
            testCertificatePrice: 5900,
            hoseLabel: false,
            hoseLabelPrice: 500,
        }
    },
    getters: {
        getPSI() {
            return 14.5;
        },
        getHosePreferences(state) {
            return state.preferences;
        },
        getHoseBuild(state) {
            return state.build;
        },
        getHosePrices(state) {
            let price = 0;

            if (state.build.selectedHose) price += state.build.selectedHose.price * Math.ceil(state.preferences.length / 1000);
            if (state.build.couplingA) price += Object.keys(state.build.couplingA).length !== 0 ? state.build.couplingA.price : 0;
            if (state.build.couplingB) price += Object.keys(state.build.couplingB).length !== 0 ? state.build.couplingB.price : 0;
            if (state.build.rotation) price += Object.keys(state.build.rotation).length !== 0 ? state.build.rotation.price : 0;

            let pressSleeveRvs = state.press.pressSleeves.find(x => x.id === state.build.selectedHose.press_sleeve_rvs_id);
            let pressSleeve = state.press.pressSleeves.find(x => x.id === state.build.selectedHose.press_sleeve_id);

            if (state.build.couplingA && state.build.couplingB) {
                if (state.build.couplingA.material === "rvs" && state.build.couplingB.material === "rvs") {
                    if (pressSleeveRvs) price += (pressSleeveRvs.price * 2);
                } else if (state.build.couplingA.material === "rvs") {
                    if (pressSleeveRvs) price += pressSleeveRvs.price;
                    if (pressSleeve) price += pressSleeve.price;
                } else if (state.build.couplingB.material === "rvs") {
                    if (pressSleeveRvs) price += pressSleeveRvs.price;
                    if (pressSleeve) price += pressSleeve.price;
                } else {
                    if (pressSleeve) price += (pressSleeve.price * 2);
                }
            }

            const pressCost = state.press.pressCosts.find(x => x.id === state.build.selectedHose.hose_press_cost_id);
            const pressCostTwo = state.press.pressCosts.find(x => x.id === state.build.selectedHose.hose_press_cost_2_id);
            const pressCostFive = state.press.pressCosts.find(x => x.id === state.build.selectedHose.hose_press_cost_5_id);
            const pressCostTen = state.press.pressCosts.find(x => x.id === state.build.selectedHose.hose_press_cost_10_id);

            let price_two = pressCostTwo ? price + pressCostTwo.price : null;
            let price_five = pressCostFive ? price + pressCostFive.price : null;
            let price_ten = pressCostTen ? price + pressCostTen.price : null;

            if (pressCost) price += pressCost.price;

            let price_two_magento = price - (price * 0.05);
            let price_five_magento= price - (price * 0.15);
            let price_ten_magento= price - (price * 0.25);

            if (state.extras.addTestCertificate) price += state.extras.testCertificatePrice;

            if (state.extras.hoseLabel) price += state.extras.hoseLabelPrice;

            return {
                price: (price / 100),
                pressCostTwo: (price_two / 100),
                pressCostFive: (price_five / 100),
                pressCostTen: (price_ten / 100),
                priceTwoMagento: (price_two_magento / 100),
                priceFiveMagento: (price_five_magento / 100),
                priceTenMagento: (price_ten_magento / 100),
            }
        },
        getBuildObject(state) {
            return {
                coupling_a_id: state.build.couplingA ? state.build.couplingA.id : null,
                coupling_b_id: state.build.couplingB ? state.build.couplingB.id : null,
                rotation_id: state.build.rotation ? state.build.rotation.id : null,
                hose_id: state.build.selectedHose ? state.build.selectedHose.id : null,
                length: state.preferences.length,
            };
        },
        getHoseExtras(state) {
            return {
                add_test_certificate: state.extras.addTestCertificate,
                test_certificate_bar_amount: state.extras.testCertificateBarAmount,
                hose_label: state.extras.hoseLabel,
            }
        }
    },

    actions: {
        setUnit: ({commit}, id) => {
            commit('setUnit', id);
        },
        setApplication: ({commit}, id) => {
            commit('setApplication', id);
        },
        setPressure: ({commit}, id) => {
            commit('setPressure', id);
        },
        setLpm: ({commit}, id) => {
            commit('setLpm', id);
        },
        setLength: ({commit}, id) => {
            commit('setLength', id);
        },
        setType: ({commit}, id) => {
            commit('setType', id);
        },
        setPopup: ({commit}, id) => {
            commit('setPopup', id);
        },
        setCouplingA: ({commit, dispatch}, id) => {
            commit('setCouplingA', id);
            dispatch('resetRotation');
        },
        setCouplingB: ({commit, dispatch}, id) => {
            commit('setCouplingB', id);
            dispatch('resetRotation');
        },
        resetRotation: ({commit, state, dispatch}) => {
            if (
                state.build.couplingA &&
                state.build.couplingA.rotatable &&
                state.build.couplingB &&
                state.build.couplingB.rotatable
            ) {
                if (state.build.rotation === null) {
                    dispatch('setFirstRotation');
                }
            } else {
                commit('setRotation', null);
            }
        },
        setMaterialA: ({commit}, id) => {
            commit('setMaterialA', id);
        },
        setSelectedCategoryA: ({commit}, id) => {
            commit('setSelectedCategoryA', id);
        },
        setSelectedHose: ({commit}, id) => {
            commit('setSelectedHose', id);
        },
        setFirstHose({rootGetters, commit}) {
            let hoses = rootGetters['build/hoses/hoses/getAll'];
            commit('setSelectedHose', hoses[0]);
        },
        setFirstAvailableCoupling({state, rootGetters, commit}) {
            let couplings = rootGetters['build/hoses/couplings/getAllCouplings'];

            const defaultCouplingId = state.build.selectedHose.default_coupling_id;
            if (typeof defaultCouplingId === 'number') {
                const defaultCoupling = couplings.find(function (coupling) {
                    return coupling.id === defaultCouplingId;
                });

                if (defaultCoupling) {
                    commit('setCouplings', defaultCoupling);
                    return;
                }

                console.warn(`Default coupling '${defaultCouplingId}' not found, using fallback`)
            }

            let material = rootGetters['build/hoses/getHosePreferences'].materialA;

            let filteredCouplings = couplings.filter(function (coupling) {
                return coupling.material === material && coupling.measurement_dn === state.build.selectedHose.measurement_dn;
            });
            commit('setCouplings', filteredCouplings[0]);
        },
        setFirstRotation({rootGetters, commit}) {
            let rotations = rootGetters['build/hoses/couplings/getAllRotations'];
            commit('setRotations', rotations[0]);
        },

        addOrder({rootState, rootGetters, commit, dispatch}) {
            const buildObject = rootGetters['build/hoses/getBuildObject'];
            const buildExtras = rootGetters['build/hoses/getHoseExtras'];

            return axios.post(process.env.VUE_APP_API_URL + 'hoses/builds/make', {
                build: buildObject,
                build_extras: buildExtras,
                locale: rootGetters['preference/getLocale'],
            })
                .then((response) => {
                    const order = {
                        type: 'hose',
                        build: response.data.buildId,
                        name: response.data.name,
                        description: response.data.description,
                        price: response.data.price,
                        price_2: response.data.price_2,
                        price_5: response.data.price_5,
                        price_10: response.data.price_10,
                        uid: response.data.uid,
                        amount: 1
                    };
                    commit('hoseItems/setCartItems', order);

                    if (response.data.hose_label) {
                        const order = {
                            type: 'hose-extra',
                            build: response.data.hose_label.sku,
                            name: response.data.hose_label.description,
                            price: response.data.hose_label.price,
                            amount: 1
                        };
                        commit('hoseItems/setCartItems', order);
                    }

                    if (response.data.test_certificate) {
                        const order = {
                            type: 'hose-extra',
                            build: response.data.test_certificate.sku,
                            name: response.data.test_certificate.description,
                            price: response.data.test_certificate.price,
                            amount: 1
                        };
                        commit('hoseItems/setCartItems', order);
                    }

                    dispatch('cart/setCartLocalStorage');

                    return order;
                });
        },
        fetchBuild({dispatch} , uid) {
            return axios.get(process.env.VUE_APP_API_URL + 'hoses/builds/' + uid)
              .then(({ data }) => {
                  return data;
              });
        },
        getBuildId({rootGetters}) {
            const buildObject = rootGetters['build/hoses/getBuildObject'];
            const buildExtras = rootGetters['build/hoses/getHoseExtras'];

            return axios.post(process.env.VUE_APP_API_URL + 'hoses/builds/make', {
                build: buildObject,
                build_extras: buildExtras,
                locale: rootGetters['preference/getLocale'],
            })
              .then((response) => {
                  return response.data.uid;
              });
        },
        loadBuild({dispatch, rootGetters, commit}, build) {
            if (build !== undefined) {
                const couplingA = rootGetters['build/hoses/couplings/getAllCouplings'].find(x => x.id === build.coupling_a_id);
                if (couplingA !== undefined) {
                    dispatch('setCouplingA', couplingA);
                }
                const couplingB = rootGetters['build/hoses/couplings/getAllCouplings'].find(x => x.id === build.coupling_b_id);
                if (couplingB !== undefined) {
                    dispatch('setCouplingB', couplingB);
                }
                const hose = rootGetters['build/hoses/hoses/getAll'].find(x => x.id === build.hose_id);
                if (hose !== undefined) {
                    dispatch('setSelectedHose', hose);
                }
                dispatch('setLength', build.length);

                const rotation = rootGetters['build/hoses/couplings/getAllRotations']
                    .find(x => x.id === build.rotation_id);
                commit('setRotation', rotation);
            }
        }
    },

    mutations: {
        setUnit(state, unit) {
            state.preferences.unit = unit;
        },
        setApplication(state, application) {
            state.preferences.application = application;
        },
        setPressure(state, pressure) {
            state.preferences.pressure = pressure;
        },
        setLpm(state, lpm) {
            state.preferences.lpm = lpm;
        },
        setLength(state, length) {
            state.preferences.length = length;
        },
        setType(state, type) {
            state.build.type = type;
        },
        setPopup(state, popup) {
            state.preferences.popupType = popup;
        },
        closePopup(state) {
            state.preferences.popupType = null;
        },
        setMaterialA(state, material) {
            state.preferences.materialA = material;
        },
        setMaterialB(state, material) {
            state.preferences.materialB = material;
        },
        setSelectedCategoryA(state, category) {
            if (_.isEqual(state.build.selectedCategoryA, category)) {
                state.build.selectedCategoryA = null;
            } else {
                state.build.selectedCategoryA = category;
            }
        },
        setSelectedCategoryB(state, category) {
            if (_.isEqual(state.build.selectedCategoryB, category)) {
                state.build.selectedCategoryB = null;
            } else {
                state.build.selectedCategoryB = category;
            }
        },
        setCouplingA(state, coupling) {
            state.build.couplingA = coupling;
        },
        setCouplingB(state, coupling) {
            state.build.couplingB = coupling;
        },
        setRotation(state, rotation) {
            state.build.rotation = rotation;
        },
        setSelectedHose(state, hose) {
            state.build.selectedHose = hose;
        },
        setCouplings(state, coupling) {
            state.build.couplingA = coupling;
            state.build.couplingB = coupling;
        },
        setRotations(state, rotation) {
            state.build.rotation = rotation;
        },
        resetSelectedHose(state) {
            state.build.selectedHose = null;
        },
        setTestCertificateBarAmount(state, barAmount) {
            state.extras.testCertificateBarAmount = barAmount;
        },
        setTestCertificate(state, testCertificate) {
            state.extras.addTestCertificate = testCertificate;
        },
        setHoseLabel(state, hoseLabel) {
            state.extras.hoseLabel = hoseLabel;
        }
    }
};
